import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable, BehaviorSubject, of } from "rxjs";

import { AuthenticationService } from "../AuthenticationService";

import { DashboardDelegate } from "./dashboard.delegate";
import { IDashboard } from "./dashboard.interface";
import { mergeMap, catchError, share } from "rxjs/operators";

export class DashboardService
{
    private dashboardSubject: BehaviorSubject<IDashboard> = new BehaviorSubject(null);
    public dashboard: Observable<IDashboard> = this.dashboardSubject;
    private dashboardData: IDashboard;

    constructor(private dashboardDelegate: DashboardDelegate,
        private authenticationService: AuthenticationService) { }

    public getDashboard(): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const userId = this.authenticationService.GetUserId();

        const response = this.dashboardDelegate.getDashboardDelegate(orgId, userId);
        return this.processDashboard(response);
    }

    /**
     * Loads the dashboard for the currently authenticated employee
     * (formerly DashboardService.getDashboard in employeeServicelib).
     */
    public getDashboardForEmployee(): Observable<boolean>
    {
        const employeeId = (this.authenticationService as any).GetEmployeeId
            ? (this.authenticationService as any).GetEmployeeId()
            : this.authenticationService.GetUserId();

        const response = this.dashboardDelegate.getDashboardByEmployeeId(employeeId);
        return this.processDashboard(response);
    }

    private processDashboard(dashboard: Observable<IDashboard>): Observable<boolean>
    {
        dashboard.subscribe(onDashboardSuccess.bind(this), onDashboardFault.bind(this));


        return dashboard.pipe(mergeMap((response: IDashboard) =>
        {
            return of(true);
        }),
            catchError(() => of(true)),
            share());

        function onDashboardSuccess(dashboard: IDashboard)
        {
            this.dashboardData = dashboard;
            this.dashboardSubject.next(this.dashboardData); 
        }

        function onDashboardFault(error: any)
        {
            //DashboardService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }
} 